import { ReactElement } from 'react';
import { Creator } from '~/clientApi/creator.model';

import { ImageWithAddLocationButton } from './ImageWithAddLocationButton';
import { ImageWithConnectButton } from './ImageWithConnectButton';

const UNITED_STATES_COUNTRY_CODE = 'US';
const UNITED_KINGDOM_COUNTRY_CODE = 'GB';

export function CountriesDistributionSTMComponent({
  creator,
  countryMap,
}: {
  creator?: Creator;
  countryMap: ReactElement;
}) {
  if (
    creator?.location &&
    // eslint-disable-next-line no-unsafe-optional-chaining
    'countryCode' in creator?.location &&
    creator?.location?.countryCode !== UNITED_STATES_COUNTRY_CODE &&
    creator?.location?.countryCode !== UNITED_KINGDOM_COUNTRY_CODE
  ) {
    return <ImageWithConnectButton creator={creator} />;
  }

  if (!creator?.location?.country) {
    return <ImageWithAddLocationButton creator={creator} />;
  }

  return countryMap;
}
